import { GeneralInfo } from 'components/product/product-create/general-info/GeneralInfo'
import { useEffect, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { constructOptionsSelect } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_PRODUCT } from 'services/apiProduct'

const INIT_FORM_UPLOAD = {
    title: null,
    url: null,
    alt_text: null,
    caption: null,
    description: null,
}

const UPLOAD_VALIDATION = {
    url: { required: 'Foto wajib diisi' },
    title: { required: 'Title wajib diisi' },
}

export const GeneralInfoContainer = ({ sectionRef, productDetail, onChangeForm, errorForm }) => {
    const [showFormUpload, setShowFormUpload] = useState(false)
    const [uploadDetail, setUploadDetail] = useState(INIT_FORM_UPLOAD)
    const [uploadType, setUploadType] = useState('')
    const { fetching: getBrandList } = useFetch(API_PRODUCT.BRAND_LIST)
    const { fetching: getProductTypeList } = useFetch(API_PRODUCT.TYPE_LIST)
    const { fetching: getCategoryList } = useFetch(API_PRODUCT.CATEGORY_LIST)
    const [options, setOptions] = useState({
        brand: [],
        product_type: [],
        category: [],
    })
    const {
        validateForm,
        errorForm: errorFormUpload,
        clearErrorForm,
    } = useValidation({
        form: uploadDetail,
        schema: UPLOAD_VALIDATION,
    })

    const onShowFormUpload = (type) => {
        setUploadType(type)
        setShowFormUpload(true)
    }

    const onHideFormUpload = () => {
        setShowFormUpload(false)
        setUploadDetail(INIT_FORM_UPLOAD)
        clearErrorForm()
    }

    const onChangeUploadDetail = (item) => {
        setUploadDetail({ ...uploadDetail, ...item })
    }

    const onDeleteMainImage = () => {
        onChangeForm({ main_image: null })
    }

    const onChangeOtherImages = (value) => {
        onChangeForm({ other_images: value })
    }

    const getAPIOption = (type, payload) => {
        switch (type) {
            case 'brand':
                return getBrandList(payload)
            case 'product_type':
                return getProductTypeList(payload)
            case 'category':
                return getCategoryList({ ...payload, childOnly: true })
            default:
                return
        }
    }

    const onSearchOptions = (type, value) => {
        getAPIOption(type, { search: value }).then((response) => {
            const newOption = constructOptionsSelect(response?.data, 'name', 'id')
            setOptions({ ...options, [type]: newOption })
        })
    }

    const onSubmitUpload = () => {
        validateForm().then(() => {
            if (uploadType === 'main-image') {
                onChangeForm({ main_image: uploadDetail })
            } else {
                const copyOtherImages = [...productDetail?.other_images]
                copyOtherImages.push(uploadDetail)
                onChangeForm({ other_images: copyOtherImages })
            }
            onHideFormUpload()
        })
    }

    useEffect(() => {
        Promise.all([getBrandList(), getProductTypeList(), getCategoryList({ childOnly: true })]).then((response) => {
            const newOptions = {
                brand: constructOptionsSelect(response[0]?.data, 'name', 'id'),
                product_type: constructOptionsSelect(response[1]?.data, 'name', 'id'),
                category: constructOptionsSelect(response[2]?.data, 'name', 'id'),
            }
            setOptions(newOptions)
        })
    }, [])

    const propsGeneralInfo = {
        sectionRef: sectionRef?.general_info,
        productDetail,
        options,
        onSearchOptions,
        onChangeForm,
        errorForm,
        showFormUpload,
        onShowFormUpload,
        onHideFormUpload,
        uploadDetail,
        onChangeUploadDetail,
        onDeleteMainImage,
        onChangeOtherImages,
        errorFormUpload,
        onSubmitUpload,
    }

    return <GeneralInfo {...propsGeneralInfo} />
}
